import React, { useEffect, useState } from 'react';
import {
  Form, Row, Col, Select,
} from 'antd';
import { Button, Input } from 'components/gyramais';
import { useQuery } from '@apollo/client';
import { LOAN_STATUSES } from '../graphql';

const { Item } = Form;
const { Option } = Select;

// Nomes de negócio da esteira Badesul por status técnico (GYR-1489).
// Status fora do mapa não são ofertados no filtro.
const badesulStatusMap = {
  new: 'Novo',
  integrated: 'Em Análise',
  registered: 'Em Análise',
  'pre-approved': 'Pré-Aprovado',
  pending: 'Pendente',
  'check-documents': 'Conferir Documentos',
  // O MPE (useBNDES) passa por análise/comitê e pela contratação BNDES entre
  // CONFERIR DOCUMENTOS e PAGAMENTO PENDENTE — agrupados como "Em Análise" para
  // o parceiro ter feedback de estágio em vez de a operação sumir do filtro.
  approval: 'Em Análise',
  'registered-approved': 'Em Análise',
  'bndes-financing': 'Em Análise',
  'bndes-financing-approved': 'Em Análise',
  'bndes-contract': 'Em Análise',
  'bndes-contract-approved': 'Em Análise',
  'awaiting-payment': 'Pagamento Pendente',
  'awaiting-signature': 'Assinatura',
  signed: 'Assinado',
  active: 'Ativo',
  completed: 'Finalizado',
};

const BusinessFilterFormBadesul = ({ forceStatusValue, onSearch }) => {
  const [form] = Form.useForm();

  const [filteredStatuses, setFilteredStatuses] = useState();
  useQuery(LOAN_STATUSES, {
    onCompleted: ({ loanStatuses }) => {
      // Vários status técnicos (BNDES do MPE) compartilham o rótulo "Em
      // Análise"; dedupa por rótulo para não repetir a opção no filtro.
      const seenLabels = new Set();
      const filtered = loanStatuses
        .filter((status) => !!badesulStatusMap[status.value])
        .map((item) => ({ ...item, name: badesulStatusMap[item.value] }))
        .filter((item) => {
          if (seenLabels.has(item.name)) {
            return false;
          }
          seenLabels.add(item.name);
          return true;
        });

      setFilteredStatuses(filtered);
    },
  });

  useEffect(() => {
    if (forceStatusValue) {
      form.setFieldValue('statusValue', forceStatusValue);
      form.setFieldValue('cnpj', undefined);
      onSearch({
        statusValue: forceStatusValue,
      });
    }
  }, [forceStatusValue]);

  return (
    <Form
      form={form}
      layout="vertical"
      className="businesses-filter-form"
      onFinish={(values) => {
        const { cnpj, statusValue } = values;
        onSearch({
          cnpj,
          statusValue,
        });
      }}
    >
      <h6>
        <b className="link-text">Filtros</b>
      </h6>
      <Row gutter={12} justify="space-between">
        <Col xs={24} sm={24} md={12}>
          <Item name="cnpj">
            <Input placeholder="CNPJ do cliente" />
          </Item>
        </Col>

        <Col xs={24} sm={24} md={8}>
          <Item name="statusValue">
            <Select
              className="gyramais-input"
              defaultValue=""
              placeholder="Selecione um status"
              loading={!filteredStatuses}
            >
              <Option value="">Todos</Option>
              {filteredStatuses?.map((element) => (
                <Option key={element.id} value={element.value}>
                  {element.name}
                </Option>
              ))}
            </Select>
          </Item>
        </Col>

        <Col xs={24} sm={24} md={4}>
          <Button block htmlType="submit">
            Filtrar
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default BusinessFilterFormBadesul;
